import { render, staticRenderFns } from "./modalAddFriendlyMatch.vue?vue&type=template&id=2c5cf863&"
import script from "./modalAddFriendlyMatch.vue?vue&type=script&lang=js&"
export * from "./modalAddFriendlyMatch.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports